<template>
  <div class="tinymce-editor">
    <editor v-model="myValue" :init="init" :ref_id="editorId" :disabled="disabled" @onClick="onClick">
    </editor>
  </div>
</template>

<script>
import tinymce from 'tinymce/tinymce'
import Editor from '@tinymce/tinymce-vue'
import 'tinymce/themes/silver/theme'
import 'tinymce/plugins/image'
import 'tinymce/plugins/media'
import 'tinymce/plugins/table'
import 'tinymce/plugins/lists'
import 'tinymce/plugins/contextmenu'
import 'tinymce/plugins/wordcount'
import 'tinymce/plugins/colorpicker'
import 'tinymce/plugins/textcolor'
import 'tinymce/plugins/fullscreen';
import '@/assets/utils/tinymce/skins/ui/oxide/skin.min.css'; //富文本样式
import 'tinymce/themes/silver/theme.min.js' //引入富文本的主要脚本
import lang from '@/assets/utils/tinymce/langs/zh_CN.js'; //引用中文语言

// tinymce.addI18n('zh_CN', lang); //注册中文语言
export default {
  components: {
    Editor
  },
  props: {
    //传入一个value，使组件支持v-model绑定
    value: {
      type: String,
      default: ''
    },
    ref_id: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    plugins: {
      type: [String, Array],
      default: 'lists image media table  wordcount fullscreen'
    },
    toolbar: {
      type: [String, Array],
      default: 'undo redo | bold italic | alignleft aligncenter alignright alignjustify | removeformat fullscreen'
    }
  },
  data() {
    return {
      //初始化配置
      init: {
        language_url: 'assets/utils/tinymce/langs/zh_CN.js',
        language: 'zh_CN',
        skin_url: 'assets/utils/tinymce/skins/ui/oxide',
        // height: 150,
        plugins: this.plugins,
        toolbar: this.toolbar,
        branding: false,
        elementpath: false,
        menubar: false,
        paste_data_images: true,
        end_container_on_empty_block: true, // enter键 分块        
        powerpaste_word_import: 'merge', // 是否保留word粘贴样式  clean | merge        
        code_dialog_height: 450, // 代码框高度 、宽度        
        code_dialog_width: 1000,
        advlist_bullet_styles: 'square', // 无序列表 有序列表
        forced_root_block: 'p',
        mode: "textareas",
        resize: true,
        remove_trailing_brs: true,
        valid_styles: {
          '*': 'font-size,color,width,height'
        },
        valid_elements: 'span,strong/b,div[align],p',
        images_upload_handler: (blobInfo, success, failure) => {
          var size = blobInfo.blob().size;
          const isLt20M = size / 1024 / 1024 < 20;
          if (!isLt20M) {
            failure('上传图片大小不能超过20M');
            return false
          }
          var xhr, formData;
          xhr = new XMLHttpRequest();
          xhr.withCredentials = false;
          xhr.open('POST', '/api/create/oss_upload');
          formData = new FormData();
          formData.append('filename', 'files')
          formData.append('files', blobInfo.blob(), blobInfo.filename());
          xhr.send(formData);
          xhr.onload = function () {
            var json;
            if (xhr.status != 200) {
              failure('HTTP Error: ' + xhr.status);
              return;
            }
            json = JSON.parse(xhr.responseText);
            if (!json || typeof json.viewPath != 'string') {
              failure('Invalid JSON: ' + xhr.responseText);
              return;
            }
            success(json.viewPath);
          };
        }
      },
      myValue: this.value,
      editorId: this.ref_id,
      cursorIndex: '',
    }
  },
  mounted() {
    tinymce.init({})
  },
  methods: {
    //添加相关的事件，可用的事件参照文档=> https://github.com/tinymce/tinymce-vue => All available events
    //需要什么事件可以自己增加
    onClick(e) {
      this.$emit('onClick', e, tinymce)
    },
    //可以添加一些自己的自定义事件，如清空内容
    clear() {
      this.myValue = ''
    },
  },
  watch: {
    value(newValue) {
      this.myValue = newValue
    },
    myValue(newValue) {
      this.cursorIndex = tinymce.activeEditor.selection.getRng().startOffset
      this.$root.$emit('cursorIndex', this.cursorIndex)
      this.$emit('input', newValue)
    }
  }
}

</script>
<style scoped>
</style>